module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('span', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Section2"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("For Jim, who never gives up on me, even when I'm at my worst.")])])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("For Brian and Jamie, who love me for myself.")])])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("And, for Mrs. Traina, whose friendship has introduced me to possibilities within myself that I had not seen.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b54912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Tempted03.vue
// module id = 63
// module chunks = 0